import { Type } from "@shared/ui/Type";

export type Props = {
  children: React.ReactNode;
  id?: string;
  title?: string;
  description?: string;
};

export function SettingsSection({ children, id, title, description }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        {title && (
          <Type as="h2" variant="h4">
            {title}
          </Type>
        )}
        {description && (
          <Type as="p" variant="body2">
            {description}
          </Type>
        )}
      </div>
      {children}
    </div>
  );
}

export default SettingsSection;
